import Sortable from "sortablejs";

document.addEventListener("DOMContentLoaded", () => {
  const sidebarFields = document.querySelector(".field-types");
  const formFieldsContainer = document.querySelector("#form-fields");
  const selectOption = document.querySelector("#field-type-field");

  // Initialize sortable for the sidebar (cloneable fields)
  Sortable.create(sidebarFields, {
    group: {
      name: "shared",
      pull: "clone",
      put: false,
    },
    sort: false,
    animation: 150,
  });

  // Initialize sortable for the form fields container
  Sortable.create(formFieldsContainer, {
    group: {
      name: "shared",
      pull: false,
      put: true,
    },
    animation: 150,
    onAdd: handleFieldAdd,
    onSort: updateFieldPositions,
  });

  // Handle click on "Add Field" buttons in the sidebar
  sidebarFields.addEventListener("click", (event) => {
    const button = event.target.closest(".add-field-btn");
    if (button) {
      const fieldType = button.dataset.type;
      if (fieldType) {
        addFieldToForm(button, fieldType);  
      }
    }
  });

  // Handle click on "Remove Field" buttons in the form container
  formFieldsContainer.addEventListener("click", (event) => {
    const removeButton = event.target.closest(".remove-field");
    if (removeButton) {
      const field = removeButton.closest(".dynamic-form-field");
      if (field) removeField(field);
    }
  });

  function handleFieldAdd(event) {
    const fieldType = event.item.dataset.type;
    if (fieldType) {
      const uniqueID = generateNewFieldId();
      const baseName = generateBaseName(event.item);
      const newFieldHTML = generateNewField(baseName, fieldType, uniqueID);

      const tempElement = document.createElement("div");
      tempElement.innerHTML = newFieldHTML;

      const newFieldElement = tempElement.firstElementChild;
      formFieldsContainer.insertBefore(newFieldElement, event.item.nextSibling);
      event.item.remove();

      updateFieldPositions();
      focusOnLastAddedField(uniqueID);
      $(".dynamic-select-dropdown").trigger("change");
      newFieldElement.classList.add('active-field');
    }
  }

  function addFieldToForm(item, fieldType) {
    const uniqueID = generateNewFieldId();
    const baseName = generateBaseName(item);
    const newFieldHTML = generateNewField(baseName, fieldType, uniqueID);

    const tempElement = document.createElement("div");
    tempElement.innerHTML = newFieldHTML;

    const newFieldElement = tempElement.firstElementChild;
    formFieldsContainer.appendChild(newFieldElement);
    updateFieldPositions();
    focusOnLastAddedField(uniqueID);
    newFieldElement.classList.add('active-field');
    handleFieldVisibility(newFieldHTML, fieldType)
    $(".dynamic-select-dropdown").trigger("change");
    newFieldElement.classList.add('active-field');

    // initializeDropdowns(); // Initialize the dropdowns for the newly added fields
  }

  // Function to remove a field
  function removeField(field) {
    const destroyInput = field.querySelector(".destroy-field");
    if (destroyInput) {
      destroyInput.value = "1"; // Mark for deletion
      field.style.display = "none";
      field.querySelectorAll("input[required]").forEach((input) => {
        input.required = false;
      });
    } else {
      field.remove();
    }
    updateFieldPositions();
  }

  // Function to generate a new field's HTML
  function generateNewField(baseName, fieldType, uniqueID) {
    const trashIcon = document.getElementById("trash-icon")?.innerHTML || "🗑️";
    const selectOptions = `
    <select name="${baseName}[${uniqueID}][field_type]" class="browser-default dynamic-select-dropdown">
      <option value="text" ${fieldType === "text" ? "selected" : ""}>Text</option>
      <option value="number" ${fieldType === "number" ? "selected" : ""}>Number</option>
      <option value="dropdown" ${fieldType === "dropdown" ? "selected" : ""}>Dropdown</option>
      <option value="date" ${fieldType === "date" ? "selected" : ""}>Date</option>
      <option value="checkbox" ${fieldType === "checkbox" ? "selected" : ""}>Checkbox</option>
      <option value="radio" ${fieldType === "radio" ? "selected" : ""}>Radio</option>
      <option value="text_area" ${fieldType === "text_area" ? "selected" : ""}>Text area</option>
      <option value="image" ${fieldType === "image" ? "selected" : ""}>Image</option>
      <option value="file" ${fieldType === "file" ? "selected" : ""}>File</option>
      <option value="heading" ${fieldType === "heading" ? "selected" : ""}>Heading</option>
      <option value="subtitle" ${fieldType === "subtitle" ? "selected" : ""}>Subtitle</option>
    </select>
  `;

  
    return `
      <div class="row m0 b1 rounded-borders-8 mb20 p10 white dynamic-form-field box-shadow" data-field-type="${fieldType}" data-id="${uniqueID}">
        <input type="hidden" class="field-position" name="${baseName}[${uniqueID}][position]" value="" />
        <input type="hidden" class="destroy-field" name="${baseName}[${uniqueID}][_destroy]" value="false" />
  
        <div class="col l12">
          <div class="row m0 p0">
            <div class="col l8 m0 p0">
              <input type="text" name="${baseName}[${uniqueID}][field_label]" placeholder="Enter field label" required />
            </div>
            <div class="col l4 s12 m0 field-type-field">
              ${selectOptions}
            </div>
          </div>
  
          <!-- Description Field (if applicable) -->
            <div class="row m0 p0 toggle-on-focus-content">
              <div class="col l6 m0 p0">
                <input class="description-field" type="text" name="${baseName}[${uniqueID}][meta_data][description]" placeholder="Enter field description (optional)" />
              </div>
            </div>
  
          <!-- Options Field (if applicable) -->
            <div class="row m0 p0">
              <div class="col l6 m0 p0 add-option-row">
                <input type="text" name="${baseName}[${uniqueID}][meta_data][options]" placeholder="(e.g., Option A, Option B, Option C)" />
              </div>
            </div>
  
          <!-- Text Area Field (if applicable) -->
            <div class="row m0 p0 input-field text-area-row">
              <div class="col l6 m0 p0">
                <textarea name="${baseName}[${uniqueID}][field_label]" placeholder="Text area field" disabled></textarea>
              </div>
            </div>
  
          <div class="bb1 mb10 toggle-on-focus-content mt20"></div>
          <div class="row m0 p0 toggle-on-focus-content">
            <div class="flex-row flex-a-c">
              <div class="flexgrow"></div>
              <!-- Multiple Option Switch -->
                <div class="switch mr10">
                  <label>
                    <input type="checkbox" name="${baseName}[${uniqueID}][multiple]" />
                    <span class="lever"></span>
                    Multiple
                  </label>
                </div>
              <!-- Required Switch -->
                <div class="switch mr10">
                  <label>
                    <input type="hidden" name="${baseName}[${uniqueID}][is_required]" value="0" />
                    <input type="checkbox" class="is-required-checkbox" name="${baseName}[${uniqueID}][is_required]" />
                    <span class="lever"></span>
                    Required
                  </label>
                </div>
              <div class="br1 mx-20"></div>
              <button class="remove-field mr20" type="button">${trashIcon}</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Function to update field positions
  function updateFieldPositions() {
    const fields = formFieldsContainer.querySelectorAll(".dynamic-form-field");
    fields.forEach((field, index) => {
      const positionInput = field.querySelector(".field-position");
      if (positionInput) positionInput.value = index + 1;
    });
  }

  // Function to focus on the last added field
  function focusOnLastAddedField(uniqueID) {
    const field = formFieldsContainer.querySelector(`[data-id="${uniqueID}"]`);
    if (field) {
      field.scrollIntoView({ behavior: "smooth", block: "center" });
      field.querySelector("input, textarea")?.focus();
    }
  }

  // Utility function to generate a unique field ID
  function generateNewFieldId() {
    return `${Date.now()}`;
  }

  // Utility function to generate a base name (placeholder logic)
  function generateBaseName(item) {
    const model = item.dataset.model || "form";
    const nested = item.dataset.nested || "fields";
    return `${model}[${nested}]`;
  }

  formFieldsContainer.addEventListener('click', function(event) {
    if (event.target.closest('.dynamic-form-field')) {
      const field = event.target.closest('.dynamic-form-field');
      const allFields = formFieldsContainer.querySelectorAll('.dynamic-form-field');
      allFields.forEach((field) => field.classList.remove('active-field'));

      field.classList.add('active-field');
    }
  });

  formFieldsContainer.addEventListener("input", (event) => {
    if (event.target.classList.contains("description-field")) {
      handleDescriptionFieldClass(event);
    }
  });

  function handleDescriptionFieldClass(event) {
    const parentRow = event.target.closest(".row");
    if (parentRow) {
      const descriptionValue = event.target.value.trim();
      
      if (descriptionValue !== "") {
        parentRow.classList.remove("toggle-on-focus-content");
      } else {
        parentRow.classList.add("toggle-on-focus-content");
      }
    }
  }

  $(document).on('change', '.dynamic-select-dropdown', function handleDynamicElement() {
    var fieldType = $(this).val(); // Get selected field type
    var field = $(this).closest('.dynamic-form-field'); // Select the current field container
    handleFieldVisibility($(field), fieldType); // Ensure field is a jQuery object
  });

  function handleFieldVisibility(field, fieldType) {
    if (!(field instanceof jQuery)) {
      field = $(field); // Ensure field is a jQuery object
    }
    var descriptionField = field.find('.description-field').closest('.row');
    var optionsField = field.find('.add-option-row');
    var textInputField = field.find('.text-input-row');
    var numberInputField = field.find('.number-input-row');
    var dateInputField = field.find('.date-input-row');
    var textAreaField = field.find('.text-area-row');
    var fileInputField = field.find('.file-input-row');
    var isRequiredField = field.find('input[name$="[is_required]"]').closest('.switch');
    var multipleField = field.find('input[name$="[multiple]"]').closest('.switch');
    var demoFieldType = field.find('.demo-field-type');
  
    // Hide all fields first
    hideAllFields(descriptionField, optionsField, textInputField, numberInputField, dateInputField, textAreaField, fileInputField, isRequiredField, multipleField, demoFieldType);
  
    // Apply visibility rules based on field type
    switch (fieldType) {
      case "text":
      case "number":
      case "date":
      case "text_area":
        showInputFields(fieldType, textInputField, numberInputField, dateInputField, textAreaField);
        descriptionField.show();
        isRequiredField.show();
        demoFieldType.show();
        optionsField.hide();
        multipleField.hide();
        break;
  
      case "dropdown":
      case "checkbox":
        descriptionField.show();
        optionsField.show();
        multipleField.show();
        isRequiredField.show();
        demoFieldType.hide();
        break;
      case "radio":
        descriptionField.show();
        optionsField.show();
        multipleField.hide();
        isRequiredField.show();
        demoFieldType.hide();
        break;
  
      case "image":
      case "file":
        descriptionField.show();
        isRequiredField.show();
        demoFieldType.show();
        multipleField.show();
        optionsField.hide();
        fileInputField.show();
        break;
  
      case "heading":
      case "subtitle":
        descriptionField.hide();
        optionsField.hide();
        isRequiredField.hide();
        multipleField.hide();
        demoFieldType.hide();
        break;
  
      default:
        break;
    }
  }
  
  // Function to hide all fields
  function hideAllFields(descriptionField, optionsField, textInputField, numberInputField, dateInputField, textAreaField, fileInputField, isRequiredField, multipleField, demoFieldType) {
    descriptionField.hide();
    optionsField.hide();
    textInputField.hide();
    numberInputField.hide();
    dateInputField.hide();
    textAreaField.hide();
    fileInputField.hide();
    isRequiredField.hide();
    multipleField.hide();
    demoFieldType.hide();
  }
  
  // Function to show input-related fields based on field type
  function showInputFields(fieldType, textInputField, numberInputField, dateInputField, textAreaField) {
    switch (fieldType) {
      case "text":
        textInputField.show();
        break;
      case "number":
        numberInputField.show();
        break;
      case "date":
        dateInputField.show();
        break;
      case "text_area":
        textAreaField.show();
        break;
      default:
        break;
    }
  }
  $('.dynamic-select-dropdown').trigger('change');
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (event) {
    if (event.target.classList.contains("is-required-checkbox")) {
      const checkbox = event.target;
      const hiddenInput = checkbox.previousElementSibling;

      if (hiddenInput && hiddenInput.type === "hidden") {
        hiddenInput.value = checkbox.checked ? "1" : "0";
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const formFieldsContainer = document.getElementById("form-fields");
  const dragDropMessage = document.querySelector(".drag-drop-message");

  function moveMessageToBottom() {
    if (dragDropMessage && formFieldsContainer.lastElementChild !== dragDropMessage) {
      formFieldsContainer.appendChild(dragDropMessage);
    }
  }

  // MutationObserver to detect changes
  const observer = new MutationObserver((mutations) => {
    let addedNodes = mutations.some(mutation => mutation.addedNodes.length > 0);
    if (addedNodes) {
      moveMessageToBottom();
    }
  });

  if (formFieldsContainer) {
    observer.observe(formFieldsContainer, { childList: true });
    moveMessageToBottom(); // Ensure message starts at the bottom
  }
});